/** @format */
import dayjs from 'dayjs';
import { FILTER_NAMES } from '../../store/store.app';

export function isCYHotelCode(h) {
  if (typeof h !== 'string') return false;
  const normalized = h.toLowerCase().replace(/[\s\-_]+/g, '');
  return normalized.includes('cy') || normalized.includes('courtyard');
}

export function isCYHotelSelected(appFilter) {
  const params = appFilter[FILTER_NAMES.PARAMETER];
  if (!Array.isArray(params)) return false;
  const hotelParam = params.find((p) => p.name === 'hotel');
  const selected = hotelParam?.selected || [];
  return selected.some(isCYHotelCode);
}

function extractDateRange(value, isCY) {
  if (!Array.isArray(value)) return null;
  const { startDate, endDate, endDateCY } = value[0];
  const effectiveEndDate = isCY && endDateCY ? endDateCY : endDate;
  return {
    start_date: dayjs(startDate).format('DD-MM-YYYY'),
    end_date: dayjs(effectiveEndDate).format('DD-MM-YYYY'),
  };
}

export function buildPayload(appFilter, required = []) {
  const payload = {};
  if (!appFilter) {
    console.log('empty appfilter provided to buildPayload', appFilter);
    return;
  }

  const isCY = isCYHotelSelected(appFilter);

  if (required.length) {
    required.forEach((filterName) => {
      switch (filterName) {
        case FILTER_NAMES.DATERANGE: {
          const dates = extractDateRange(appFilter[filterName], isCY);
          if (!dates) return;
          payload['start_date'] = dates.start_date;
          payload['end_date'] = dates.end_date;
          break;
        }
        case FILTER_NAMES.CALC_DATERANGE: {
          const dates = extractDateRange(appFilter[filterName], isCY);
          if (!dates) return;
          payload['start_date'] = dates.start_date;
          payload['end_date'] = dates.end_date;
          break;
        }
        case FILTER_NAMES.PARAMETER: {
          const value = appFilter[filterName];
          if (Array.isArray(value) && value.length) {
            value.forEach((attribute) => {
              const { name, selected } = attribute;
              if (selected.length) payload[name] = selected;
            });
          }
        }
      }
    });
    return payload;
  }

  for (const filter in appFilter) {
    const value = appFilter[filter];
    if (!value) continue;
    if (filter === FILTER_NAMES.CALC_DATERANGE && Array.isArray(value)) {
      const dates = extractDateRange(value, isCY);
      payload['start_date'] = dates.start_date;
      payload['end_date'] = dates.end_date;
    } else if (
      filter === FILTER_NAMES.PARAMETER &&
      Array.isArray(value) &&
      value.length
    ) {
      value.forEach((attribute) => {
        const { name, selected } = attribute;

        if (selected.length) payload[name] = selected;
      });
    } else {
      // console.log('SKIPPED: [buildPayload]', filter);
    }
  }
  return payload;
}
